module.exports = __webpack_public_path__ + "fonts/SFUIText-Semibold.fd5fedc9.woff";